import React from "react";
import { Avatar, Badge, Col, Dropdown, Menu, Row, Typography } from 'antd';
import { LoginOutlined, UserOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
import BaseComponent from "../../../redare/components/BaseComponent";
import logo from "../../../assets/img/logo.png";
import WebWorkbenchPresenter from "../../../.gen/presenter/WebWorkbenchPresenter";

const { Text } = Typography;

export default class Header extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            visible: false,
        };
        this.presenter = new WebWorkbenchPresenter(this);
    }

    loginOut() {
        this.presenter.loginOut(null, () => {
            // window.location.reload();
            window.location.href = window._ctx + "/login"
        });
    }

    render() {
        let user = window._workbench?._user ?? {};
        let title = () => {
            if (window.location.host == "sykjinfo.ynshine.com") {
                return "盛云科技有限公司";
            } else if (window.location.host == "www.ynshine.com") {
                let pathname = window.location.pathname.split("/")[1];
                if (pathname == "cyhy") {
                    return "云南重邮慧云电力工程有限公司";
                }
                if (pathname == "shenglian") {
                    return "昆明盛联消防设施维护管理有限公司";
                }
            }
        }
        return (
            <div className="width-all">
                <Row gutter={24} type="flex" justify="space-between" className="container">
                    <Col>
                        <div className="logo">
                            <a href="/workbench">
                                <Row gutter={8}>
                                    {/* <Col>
                                       <img className="" src={logo} alt="logo"/>
                                    </Col> */}
                                    <Col>
                                        <h1>{title()}</h1>
                                    </Col>
                                    <Col>
                                        <h1>统一门户</h1>
                                    </Col>
                                </Row>

                            </a>
                        </div>
                    </Col>
                    <Col className="nav-box">
                        <Menu className="nav-menu" mode="inline" defaultSelectedKeys={['1']} mode="horizontal">
                            <Menu.Item><Link to="/">工作台</Link></Menu.Item>
                            <Menu.Item><Link to="/unified"><span>统一登录</span></Link></Menu.Item>
                            <Menu.Item><Link to="/site"><span>系统设置</span></Link></Menu.Item>
                            {/*<Menu.Item><Link to="/report"><span>数据报表</span></Link></Menu.Item>*/}
                        </Menu>
                    </Col>
                    <Col>
                        <Row gutter={24} justify="end" align="middle" style={{ height: '100%' }}>
                            <Col>
                                <Dropdown overlay={
                                    <Menu className="use-menu">
                                        <Menu.Item key="0">
                                            <Link to="/site/profile"><UserOutlined /><span
                                                className="padding-left05">个人设置</span></Link>
                                        </Menu.Item>
                                        <Menu.Divider />
                                        <Menu.Item key="2" onClick={this.loginOut.bind(this)}><LoginOutlined /><span
                                            className="padding-left05">退出登录</span></Menu.Item>
                                    </Menu>}>
                                    <Badge className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                                        <Avatar icon={<UserOutlined />} src={user.photo} />
                                        <Text style={{ marginLeft: '10px', paddingRight: '5px', cursor: 'default' }}>{user.name}</Text>
                                    </Badge>
                                </Dropdown>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }
}
